import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    background-color: ${theme.colors.gray.Cinza_13};
    border-radius: 10px;
    padding: 20px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Title = styled.h2`
    margin: 0;
    font-family: Lato;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: ${theme.colors.gray.Cinza_7};
`;

export const ChartWrapper = styled.div`
    margin-top: 20px;
    height: 295px;
`;

export const LoadingBox = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
